export default "__VITE_ASSET__35784b4c__"